export default "__VITE_ASSET__BsU3bM_w__"